
var grid = {
    columnsCount: 0,
    headerCols: null,
    grid: null,

    init: function(grid) {
        this.grid = grid;
        this.headerCols = grid.find('.header .cell');
        this.columnsCount = this.headerCols.length;

        this.setCellWidths(this.grid.find('.row.content'));
        this.bindEditable(this.grid.find('.row.content'));
    },

    bindEditable: function(rows) {
        var fields = rows.find('[contenteditable]');
        connection.applyValueChange(fields, {
            onChange: function() {
                messaging.showGlobalMessage('success', null, 'Änderung erkannt');
            },
            onLeave: function(el) {
                window.scroll(0,0);
                el.removeClass('selected');
            }
        });
        fields.click(function() {
            if (!$(this).hasClass('selected')) {
                document.execCommand('selectAll', false, null);
                $(this).addClass('selected');
            }
        });
        fields.keypress(function(e) { return e.which != 13; } );
    },

    setCellWidths: function(rows) {
        var headerWidths = $.map(this.headerCols,function(val){
            return $(val).outerWidth();
        });
        for (var i = 0; i < rows.length; i++) {
            var cells = $(rows[i]).find('.cell');
            for (var c = 0; c < cells.length; c++) {
                cells[c].style.width = headerWidths[c]+'px';
            }
        }
    }

};
window.grid = grid;

$( document ).ready(function() {
    $.each($('div.grid'), function() {
        grid.init($(this));
    });
});
